/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconCalendar14 extends React.Component {
  render() {
    const iconClasses = classNames("icon calendar14", this.props.className);
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M 6 4 C 4.895 4 4 4.895 4 6 L 4 24 C 4 25.105 4.895 26 6 26 L 24 26 C 25.105 26 26 25.105 26 24 L 26 6 C 26 4.895 25.105 4 24 4 L 6 4 z M 6 6 L 24 6 L 24 10 L 6 10 L 6 6 z M 10.638672 14.496094 L 12.429688 14.496094 L 12.429688 21.542969 L 10.638672 21.542969 L 10.638672 16.113281 L 10.544922 16.113281 L 8.8457031 17.259766 L 8.8457031 15.716797 L 10.638672 14.496094 z M 17.839844 14.498047 L 20.324219 14.498047 L 20.324219 19.005859 L 21.203125 19.005859 L 21.203125 20.400391 L 20.324219 20.400391 L 20.324219 21.544922 L 18.630859 21.544922 L 18.630859 20.400391 L 15.173828 20.400391 L 15.173828 18.902344 C 15.813828 17.676344 16.623844 16.343047 17.839844 14.498047 z M 18.585938 15.777344 C 17.984938 16.705344 17.511703 17.505469 16.720703 18.980469 L 16.720703 19.068359 L 18.673828 19.068359 L 18.673828 15.777344 L 18.585938 15.777344 z" />
      </svg>
    );
  }
}

IconCalendar14.defaultProps = {
  className: null
};

IconCalendar14.propTypes = {
  className: PropTypes.string
};

export default IconCalendar14;
